import { motion } from "framer-motion";
import { Eyebrow } from "@/components/primitives";
import Sprig from "@/components/Sprig";

export default function PageHero({ eyebrow, title, intro, script, image, imageAlt = "" }) {
  const hasImage = Boolean(image);
  return (
    <section className="relative pt-20 pb-16 md:pt-28 md:pb-20 bg-brand-lavender-soft/40 border-b border-brand-line/60 overflow-hidden">
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-brand-accent/60 blur-3xl" />
      <div className={`relative max-w-7xl mx-auto px-6 md:px-12 ${hasImage ? "grid lg:grid-cols-2 gap-10 lg:gap-16 items-center" : ""}`}>
        <motion.div
          initial={{ opacity: 0, y: 22 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className={hasImage ? "" : "max-w-3xl"}
        >
          {eyebrow && <Eyebrow className="block mb-6">{eyebrow}</Eyebrow>}
          {script && (
            <span className="flex items-center gap-3 font-heading font-medium text-brand-lavender-dark leading-[1.06] text-[2.06rem] md:text-[2.45rem]">
              <span>{script}</span>
              <Sprig className="h-8 md:h-10 -mt-1" />
            </span>
          )}
          <h1 className="font-heading font-medium text-brand-forest leading-[1.06] text-[2.03rem] sm:text-[2.7rem] lg:text-[3.375rem]">
            {title}
          </h1>
          {intro && (
            <p className="mt-6 font-body text-base md:text-lg text-brand-slate leading-relaxed">{intro}</p>
          )}
        </motion.div>

        {hasImage && (
          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <div className="overflow-hidden rounded-[2rem] border border-white/70 shadow-[0_24px_70px_rgba(59,92,69,0.16)]">
              <img
                src={image}
                alt={imageAlt}
                className="w-full h-[16rem] sm:h-[20rem] lg:h-[24rem] object-cover"
              />
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
}
